import AccessoryCard from "./AccessoryCard.jsx";
import s from "./AccessoriesCatalog.module.css";

export default function AccessoriesCatalog({
  products,
  totalCount,
  onAddToCart,
  isLoading,
}) {
  if (isLoading) return null;

  return (
    <section className={s.catalog} id="accessories-catalog">
      <div className={s.meta}>
        Showing <strong>{products.length}</strong> of{" "}
        <strong>{totalCount}</strong> accessories
      </div>
      <div className={s.grid}>
        {products.length > 0 ? (
          products.map((product, i) => (
            <AccessoryCard
              key={product.product_id}
              product={product}
              index={i}
              onAddToCart={onAddToCart}
            />
          ))
        ) : (
          <div className={s.empty}>
            <strong className={s.emptyTitle}>
              No accessories in this category yet.
            </strong>
            Try a different category to see what's in stock.
          </div>
        )}
      </div>
    </section>
  );
}
